"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _rowConfig = _interopRequireDefault(require("../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../core/label"));
var _col = _interopRequireDefault(require("../../../core/col"));
var _inputOnBlur = _interopRequireDefault(require("../../../core/input-on-blur"));
var _selectCode = _interopRequireDefault(require("../../../core/select-code"));
var _submit = _interopRequireDefault(require("../../../core/submit"));
var _button = _interopRequireDefault(require("../../../core/button"));
var _modal = _interopRequireDefault(require("../../../core/modal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  addingSpecial: false,
  isSubmitting: false,
  newSpecial: {
    specialRef: null,
    specialNote: null
  }
};
var _ref = /*#__PURE__*/_react.default.createElement(_label.default, null, "Special Type*");
class NewSpecial extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_toggleAddingSpecial", () => {
      this.setState({
        addingSpecial: !this.state.addingSpecial
      });
    });
    _defineProperty(this, "_setValue", (field, value) => {
      this.setState({
        newSpecial: {
          ...this.state.newSpecial,
          [field]: value
        }
      });
    });
    _defineProperty(this, "_onSubmit", e => {
      e.preventDefault();
      if (this.state.isSubmitting) return;
      this.setState({
        isSubmitting: true
      });
      return this.props.onSubmit(this.state.newSpecial).then(() => this.setState(initialState));
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._toggleAddingSpecial,
      type: "default",
      style: {
        padding: '0',
        whiteSpace: 'normal'
      }
    }, /*#__PURE__*/_react.default.createElement("strong", null, (0, _occasion.default)(this.props.calendarDateID, 'dddd'))), !this.state.addingSpecial ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: 'Add Special for ' + (0, _occasion.default)(this.props.calendarDateID, 'dddd'),
      onClose: this._toggleAddingSpecial
    }, /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: this._onSubmit
    }, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4
      }, {
        sm: 8
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "RefCodes",
      codeType: "calendarspecial",
      value: this.state.newSpecial.specialRef,
      onChange: this._setValue.bind(this, 'specialRef'),
      name: "specialRef",
      clearable: false
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, /*#__PURE__*/_react.default.createElement(_label.default, null, this.state.newSpecial.specialRef === 'OTHR' ? 'Note*' : 'Note'), /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "text",
      name: "specialNote",
      value: this.state.newSpecial.specialNote,
      onChange: this._setValue.bind(this, 'specialNote'),
      maxLength: 100,
      required: this.state.newSpecial.specialRef === 'OTHR'
    })))), /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._toggleAddingSpecial
    }, "Cancel"), ' ', /*#__PURE__*/_react.default.createElement(_submit.default, {
      loading: this.state.isSubmitting
    }, "Save")))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = (0, _reactBicycle.connect)(NewSpecial, undefined, (client, props) => ({
  onSubmit(newSpecial) {
    return client.update('ApplicationSpecial.create', {
      calendarID: props.calendarID,
      dayNumber: props.dayNumber,
      applicationID: props.applicationID,
      ...newSpecial
    });
  }
}));